import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import {
  FirestoreCollectionReference,
  FirestoreDocumentReference,
} from "../../../../../api/firebase/references";
import { AuthorizationLetterConfig } from "../authorizationLetterConfiguration";

export const fetchAuthorizationLetterConfig = async (
  orgId: string,
): Promise<AuthorizationLetterConfig | null> => {
  try {
    const config =
      await FirestoreService.getDocument<AuthorizationLetterConfig>(
        FirestoreDocumentReference.authorizationLetterConfig(orgId),
      );
    return config;
  } catch (error) {
    // If document doesn't exist, return null (will use defaults)
    if ((error as any)?.code === "not-found" || (error as any)?.code === 5) {
      return null;
    }
    throw error;
  }
};

export const updateAuthorizationLetterConfig = async (
  orgId: string,
  config: AuthorizationLetterConfig,
  userEmail?: string | null,
): Promise<void> => {
  const configWithTimestamp = {
    ...config,
    updated_at: new Date().toISOString(),
    updated_by: userEmail || "system",
  };

  const collectionPath =
    FirestoreCollectionReference.authorizationLetter(orgId);

  await FirestoreService.setDocument(
    collectionPath,
    "latest",
    configWithTimestamp,
  );
};
